const SEND_EMAI_URI = process.env.REACT_APP_EMAILEND_POINT;
const SEND_ONYX_EMAIL_URI=process.env.REACT_APP_ONYX_EMAILEND_POINT

export const urls = {
  applications: {
getRegisterApplicaiton: (
    payerId: any,
    environment: string,
    pageNumber: number,
    pageSize: number,
    applicationName?: string,
    applicationStatus?: number
  ) => {
    const params = new URLSearchParams({
      PayerID: payerId,
      environment,
      pageNumber: String(pageNumber),
      pageSize: String(pageSize),
      sortBy: "createdAt",
      sortOrder: "desc",
    });

    if (applicationName) {
      params.append("applicationName", applicationName);
    }

    if (applicationStatus !== undefined) {
      params.append("applicationStatus", String(applicationStatus));
    }

    return `/SSO/GetRegisteredApps?${params.toString()}`;
  },
    getApplicationById: (id: number) => `/SSO/GetRegisteredApps/${id}`,
    updateApplicationStatus:
      "https://aaneelconnect-api-sandbox.aaneelconnect.com/SSO",

    getPayerMembers: (
      MemberID: any,
      FirstName: any,
      LastName: any,
      DOB: any,
      Email: any,
      PageNumber: number,
      PageSize: number,
    ) => {
      let queryParams = [];

      // Add query parameters only if they are provided
      if (MemberID) queryParams.push(`MemberID=${MemberID}`);
      if (FirstName) queryParams.push(`FirstName=${FirstName}`);
      if (LastName) queryParams.push(`LastName=${LastName}`);
      if (DOB) queryParams.push(`DOB=${DOB}`);
      if (Email) queryParams.push(`Email=${Email}`);
      if (PageNumber) queryParams.push(`PageNumber=${PageNumber}`);
      if (PageSize) queryParams.push(`PageSize=${PageSize}`);
      // Add pagination and sorting parameters (which are always required)
      // queryParams.push(`PageNumber=1`);
      // queryParams.push(`PageSize=10`);
      queryParams.push(`SortBy=addDate`);
      queryParams.push(`SortOrder=desc`);

      // Join all parameters with '&' and return the full URL
      return `/PortalMember/members?SortBy=addDate&SortOrder=desc&${queryParams.join("&")}`;
    },
    getPortalUsersList: (
      FirstName: string,
      LastName: string,
      Username: string,
      Email: string,
      IsActive: any,
      PageNumber: number,
      PageSize: number,
      UserRole?: any,
    ) => {
      let queryParams = [];

      // Add query parameters only if they are provided
      if (FirstName) queryParams.push(`FirstName=${FirstName}`);
      if (LastName) queryParams.push(`LastName=${LastName}`);
      if (Username) queryParams.push(`Username=${Username}`);
      if (Email) queryParams.push(`Email=${Email}`);
      if (IsActive) queryParams.push(`IsActive=${IsActive}`);
      if (PageNumber !== undefined && PageNumber !== null) {
        queryParams.push(`PageNumber=${PageNumber}`);
      }
      if (PageSize !== undefined && PageSize !== null) {
        queryParams.push(`PageSize=${PageSize}`);
      }
      if (UserRole !== undefined && UserRole !== null && UserRole !== "") {
        queryParams.push(`UserRole=${UserRole}`);
      }
      queryParams.push(`SortBy=addDate`);
      queryParams.push(`SortOrder=desc`);
      // Return the full URL
      return `/PortalUser/users?SortBy=addDate&SortOrder=desc&${queryParams.join("&")}`;
    },

    getUserRoles: "/PortalRoles/roles",
    getUserByID: (id: any) => `/PortalUser/user/${id}`,
    updateUser: "/PortalUser/user",
    createUser: "/PortalUser/user",
    getUserByEmail: (email: string) =>
      `/PortalUser/user-by-email?email=${email}`,
    getMemberBySSOID: (ssoID: string) => `/PortalUser/user-by-ssoid/${ssoID}`,
    sendEmail: SEND_EMAI_URI,
    sendOnyxEmail:SEND_ONYX_EMAIL_URI
  },
  // AaNeelConnect: ServiceProviderController, CPTController, PAConfigurationIntegrationController
  providerIntegration: {
    // ServiceProviderController — GET/POST /api/providers
    providers: "/api/providers",
    // ServiceProviderController — GET/PUT /api/providers/{id}
    providerById: (id: number) => `/api/providers/${id}`,

    // CPTController — GET /api/cpt-codes?search= (all providers)
    cptCodesSearch: (search: string) =>
      `/api/cpt-codes?search=${encodeURIComponent(search)}`,

    // CPTController — GET (paged) /api/providers/{providerId}/cpt-codes
    cptCodes: (
      providerId: number,
      pageNumber: number,
      pageSize: number,
      search?: string,
    ) => {
      const params = new URLSearchParams({
        pageNumber: String(pageNumber),
        pageSize: String(pageSize),
      });
      if (search) params.append("search", search);
      return `/api/providers/${providerId}/cpt-codes?${params.toString()}`;
    },
    // CPTController — POST add / PUT update /api/providers/{providerId}/cpt-codes
    cptCodesBase: (providerId: number) =>
      `/api/providers/${providerId}/cpt-codes`,
    // CPTController — POST /api/providers/{providerId}/cpt-codes/import
    cptCodesImport: (providerId: number) =>
      `/api/providers/${providerId}/cpt-codes/import`,
    // CPTController — DELETE path without query
    cptCodeById: (providerId: number, cptCodeId: number) =>
      `/api/providers/${providerId}/cpt-codes/${cptCodeId}`,
    // CPTController — DELETE /api/providers/{providerId}/cpt-codes/{cptCodeId}?userId=
    cptCodeDelete: (
      providerId: number,
      cptCodeId: number,
      userId: string,
    ) =>
      `/api/providers/${providerId}/cpt-codes/${cptCodeId}?userId=${encodeURIComponent(userId)}`,

    // PAConfigurationIntegrationController — POST upsert
    paConfiguration: "/api/PAConfigurationIntegration",
    // PAConfigurationIntegrationController — GET by provider + type
    // Omit authTypeId to load the active configuration for the group.
    paConfigurationByProvider: (
      providerId: number,
      integrationType: string,
      authTypeId?: number,
      configurationTypeId?: number,
    ) => {
      const params = new URLSearchParams({
        providerId: String(providerId),
        integrationType,
      });
      if (authTypeId != null) {
        params.append("authTypeId", String(authTypeId));
      }
      if (configurationTypeId != null) {
        params.append("configurationTypeId", String(configurationTypeId));
      }
      return `/api/PAConfigurationIntegration?${params.toString()}`;
    },

    // ConfigurationTypeController — GET by integration type
    configurationTypes: (integrationType: string) =>
      `/api/ConfigurationType?integrationType=${encodeURIComponent(integrationType)}`,

    authTypes: "/api/AuthType",
  },
  edi: {
    client: "/v1/x12/admin/client",
    explorer: "/v1/x12/admin/explorer",
    overrides: "/v1/x12/admin/overrides",
  },
  feature: {
    getAllMenusAndFeatures: (memberType?: string) =>
      memberType
        ? `/Feature/GetAllMenusAndFeatures?memberType=${encodeURIComponent(
            memberType,
          )}`
        : "/Feature/GetAllMenusAndFeatures",
    getApplicationFeaturesAndMenus: (memberType?: string) =>
      memberType
        ? `/Feature/ApplicationFeaturesAndMenus?memberType=${encodeURIComponent(
            memberType,
          )}`
        : "/Feature/ApplicationFeaturesAndMenus",
    updateFeatureClientMapping: "/Feature/UpdateFeatureClientMapping",
    updateMenuSequence: "/Feature/UpdateMenuSequence",
  },
};
